import React from 'react'
import PropTypes from 'prop-types'
import withPolyglot from '../../../../common/withPolyglot'

import './MedicineBox.css'

const MedicineBox = ({missing, adverse, expected, sequence, date, translate, type}) => {
  // console.log(`missing - ${missing},  adverse - ${adverse}, expected - ${expected}, sequence - ${sequence}, date - ${date}, type - ${type},`)
  let icon = 'check'
  if (missing) {
    icon = 'warning'
  } else if (expected) {
    icon = ''
  } else if (adverse) {
    icon = 'warning'
  }
  let borderWidth = 1
  let borderColor = 'black'
  if (missing || expected) {
    if (missing) {
      borderWidth = 2
    }
    if (expected) {
      borderColor = 'grey'
    }
  }
  if (adverse) {
    borderWidth = 3
  }
  return (
    <div
      className={`medicine-box uk-grid ${type === 'immunoglobulin' ? 'immunoglobulin' : ''}`}
      data-uk-grid
      style={{borderWidth: borderWidth, borderColor: borderColor}}>
      <div className='uk-width-1-1 name'>
        {type === 'immunoglobulin'
          ? <span className='uk-text-small'>{`${translate('immunoglobulin', true, 'receipt')}`}</span>
          : <span className='uk-text-small'>{`${translate('numberOfShot', true, 'receipt')} ${sequence}`}</span>
        }

      </div>
      <div className='uk-width-3-4 date'>
        <span className={`uk-text-xsmall ${expected ? 'uk-text-muted' : ''}`}>
          {missing ? (
            <span className='uk-text-bold'>{translate('missing', true, 'Receipt')}</span>
          ) : expected ? (
            date
          ) : (
            date
          )}
        </span>
      </div>
      <div className='uk-width-1-4 icon'>
        <span className='medicine-box-icon'>
          {type === 'immunoglobulin'
            ? <div className='immunoglobulin-icon' />
            : <span
              className={`medicine-box-icon ${adverse ? 'warning-icon' : 'check-icon'}`}
              data-uk-icon={`icon: ${icon};ratio: 1`} />
          }
        </span>
      </div>
    </div>
  )
}

MedicineBox.propTypes = {
  missing: PropTypes.bool.isRequired,
  adverse: PropTypes.bool.isRequired,
  expected: PropTypes.bool.isRequired,
  sequence: PropTypes.number.isRequired,
  date: PropTypes.string.isRequired,
  translate: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired
}

MedicineBox.defaultProps = {
  missing: false,
  adverse: false,
  type: 'vaccine',
  expected: false
}

export default withPolyglot(MedicineBox, 'medicineBox')
